// ************************* React Libary Imports ****************************
import React, { useState, useEffect, useCallback } from "react";
import SkeletonLoader from "react-loading-skeleton";
import CommonHeader from "../../components/common-header";
// ************************* Images Imports ****************************

// ************************* Redux Imports ****************************
import { useDispatch, useSelector } from "react-redux";
import { getFacilitiesDetails } from "../../api/list";
import {
  fetchCountDetails,
  fetchPatientLookup,
} from "../../redux/slices/patientlookup.slice";
import { useNavigate } from "react-router-dom";

// ************************* Component Imports ****************************
import Table from "../../components/table/table";
import { Each } from "../../components/each";
import { debounce } from "../../utils/redirections";
import Tabs from "../../components/tabs";
// ********************************* inter face  ********************************
import { sortInterFace } from "../../utils/types/interFace";
import { WordTitle } from "../../utils/commonFunction";

const Index = () => {
  const [Selected, setSelected] = useState("All");
  const [showSearch, setShowSearch] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState<sortInterFace>({ lastName: "asc" });
  const [totalRecords, setTotalRecords] = useState(0);
  const [limit] = useState(15);
  // eslint-disable-next-line
  const handleSearch = useCallback(debounce(setSearch, 500), []);
  const [facId, setFacId] = useState([]);
  const [selectedFacId, setSelectedFacId] = useState("");
  const [activeTab, setActiveTab] = useState("Current");
  const [patientCountload,setPatientCountload] = useState(false)

  const result = useSelector(
    (state: any) => state?.patientlookUp?.patientlookup
  );
  const count = useSelector((state: any) => state?.patientlookUp?.count);
  const dispatch:any = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState<boolean>(true);

  /**
   * @function handleFetch
   * @returns
   * @description handle fetch
   */
  const handleFetch = async (facId?:any): Promise<void> => {
    try {
      await dispatch(fetchCountDetails({ status: activeTab,
         fac_id: (facId || selectedFacId) })).then(
        (res: any) => {
          setLoader(false);
          setPatientCountload(false)
        }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  /**
   * @function handleUsersData
   * @returns
   * @description handle fetch
   */
  const handleUsersData = (
    load: boolean,
    sorting: any = {},
    pageNumber?: number,
    seleted?: string,
    facId?: string
  ) => {
    pageNumber && setPage(pageNumber);
    if (pageNumber || page === 1) {
      setLoader(load);
      if (seleted === undefined){
        setPatientCountload(true)
      }
    }
    handleFetch(facId || selectedFacId);
    dispatch(
      fetchPatientLookup({
        page: pageNumber || page,
        limit,
        sort_by:
          Object.keys(sorting).length !== 0
            ? Object.keys(sorting)[0]
            : "created_at",
        sort_dir:
          Object.keys(sorting).length !== 0
            ? sorting[Object.keys(sorting)[0]]
            : "asc",
        search_value: search,
        fac_id: facId ? facId :selectedFacId,
        name_first: seleted || Selected,
        status: activeTab || "",
      })
    ).then((res: any) => {
      setSelectedFacId(facId || selectedFacId)
      setLoader(false);
      setTotalRecords(res?.payload?.total_count);
    });
  };

  useEffect(() => {
    page === 1 ? handleUsersData(true, sort) : setPage(1);
    // eslint-disable-next-line
  }, [limit, search]);

  useEffect(() => {
    handleUsersData(true, sort);
    // eslint-disable-next-line
  }, [page, activeTab]);

  useEffect(() => {
    handleSearch(showSearch);
    // eslint-disable-next-line
  }, [showSearch, selectedFacId]);

  useEffect(() => {
    handleFetch();
    handleFaclities();
    // eslint-disable-next-line
  }, []);

  /**
   * @function handleFaclities
   * @returns
   * @description handle faclities
   * */
  const handleFaclities = async () => {
    try {
      const result = await getFacilitiesDetails();
      if (result?.result) {
        setFacId(result?.result?.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  /**
   * @function handleNextPage
   * @description Handle Next Page
   * @returns Null
   * */
  const handleNextPage = () => {
    setPage(page + 1);
  };

  /**
   * @function handleFaclitiesChange
   * @param e
   * @returns
   * @description handle faclities change
   * */
  const handleFaclitiesChange = (e: any) => {
    setSelectedFacId(e.target.value);
    setPatientCountload(true)
    handleUsersData(true, sort,1, Selected, e.target.value);
  };
  /**
   * @function handlePatientLetterChange
   * @param letter string
   * @returns
   * @description handle faclities change
   * */
  const handlePatientLetterChange = (letter: any) => {
    setSelected(letter);
    handleUsersData(true, sort,1, letter, selectedFacId);
  };

  return (
    <div className="w-full p-[10px] pl-[2px] pr-[2px]">
      <div className="pt-[16px]  pl-[2px] pr-[2px] bg-white rounded-[12px]">
        <CommonHeader
          heading="Patient Lookup"
          description="View all your resident details here"
          totalCount={totalRecords}
          countForText="Results"
          options={facId}
          handleSelect={handleFaclitiesChange}
          setShowSearch={setShowSearch}
          showSearch={showSearch}
          showValue="facilityName"
          searchDropdown
        />
        <div className="grid grid-cols-12 ">
          <div className="col-span-4">
            <Tabs
              tabs={["New","Current","Discharged"]}
              value={activeTab}
              onChange={(tab: string) => {
                setActiveTab(tab);
                setPage(1);
              }}
              className="mb-2 bg-[#F9F9F9] border border-4 border-[#F9F9F9] rounded-lg"
            />
          </div>
        </div>

        <div className="flex justify-between items-center mb-[16px]">
          <div className="w-full rounded-[8px] bg-[#F9F9F9] min-h-[48px] flex items-center px-[16px]">
            {patientCountload ? (<div className="w-full h-full grid grid-cols-[repeat(27,minmax(0,1fr))] gap-4">
                {Array.from({ length: 27 }).map((_, index) => (
                  <div key={index}>
                    <SkeletonLoader width="100%" height="50px" />
                  </div>
                ))}
              </div>):(
            <div className="grid grid-cols-[repeat(27,minmax(0,1fr))] gap-4 w-full">
              {count?.result?.length > 0 && (
                <Each
                  of={count.result}
                  render={(item: any, index: any) => (
                    <div key={index}>
                      <div
                        className={`flex flex-col my-[4px] items-center cursor-pointer 
                    ${
                      Selected === item.name
                        ? "rounded-[4px] border-top  border-[#C2E9EC] text-[#147078] w-full"
                        : "bg-[#F9F9F9] w-full hover:text-green-900"
                    }`}
                        onClick={() => {
                          handlePatientLetterChange(item.name)
                        }}
                      >
                        <p className={`text-center px-2 ${Selected === item.name ? "bg-tertiary-light rounded-lg":""}`}>
                          <span className="text-[12px] font-[500]">
                            {item.name}
                          </span>
                          <br />
                          <span className="text-center text-[12px] font-[500] pl-[4px]">
                            ({item.value})
                          </span>
                        </p>
                      </div>
                    </div>
                  )}
                />
              )}
            </div>)}
          </div>
        </div>
        <div>
          <Table
            loading={loader}
            data={result?.data ? result?.data : []}
            tableScroll={"100%"}
            hasNextPage={page < result?.total_pages}
            NextPageData={handleNextPage}
            Clickable={true}
            rowClick={(row: any) => {
              navigate(`/patient-lookup/${row?.id}`)
            }}
            columns={
              [
                "Name",
                "DOB",
                "Gender",
                "Locations",
                "Status"
                // "Action",
              ]
            }
            sort={true}
            sortTitleKeys={{ Name: "lastName", Locations: "location","Gender":"gender" }}
            handleSortfunc={(key: any, value: any) => {
              setSort({ [key]: value });
              page === 1
                ? handleUsersData(true, { [key]: value })
                : handleUsersData(true, { [key]: value }, 1);
            }}
            scopedSlots={{
              Name: ({ row }: any) => (
                <td title={`${row?.lastName}, ${row?.firstName}`}>
                  <div className=" max-w-[500px] truncate cursor-pointer">
                    {row?.lastName}, {row?.firstName}
                  </div>
                </td>
              ),
              "DOB": ({ row }: any) => (
                <td title={row?.birthDate || ""}>
                  <div className=" max-w-[500px] truncate cursor-pointer">
                    {row?.birthDate}
                  </div>
                </td>
              ),
              Gender: ({ row }: any) => (
                <td title={row?.gender || ""}>
                  <div className=" max-w-[500px] truncate cursor-pointer">
                    {WordTitle(row?.gender)}
                  </div>
                </td>
              ),
              Locations: ({ row }: any) => (
                <td title={row?.location || ""}>
                  <div className=" max-w-[500px] truncate cursor-pointer">
                    {row?.location}
                  </div>
                </td>
              ),
              Status: ({ row, index }: any) => (
                <td title={row?.patientStatus || ""}>
                  <div className=" max-w-[500px] truncate cursor-pointer">
                    {row?.patientStatus}
                  </div>
                </td>
              ),
              // Action: ({ row }: any) => (
              //   <td>
              //     <Link to={`/patient-lookup/${row?.id}`}>
              //       <div className="flex text-lg items-center justify-center pr-[4px]">
              //         <LuExternalLink  />
              //       </div>
              //     </Link>
              //   </td>
              // ),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Index;

